

import Vue from 'vue'
import Router from 'vue-router'

import VueScrollTo from 'vue-scrollto'
import miniToastr from 'mini-toastr'
import VueCollapse from 'vue2-collapse'
import VTooltip from 'v-tooltip'
import axios from 'axios'
import globalMixin from '../mixins/global.js'


import MentalApp from '../MentalApp.vue'
import router from '../router/mental.js'
import store from '../store/index.js'
import {format} from "date-fns";

Vue.config.productionTip = false

Vue.use(VueScrollTo)
Vue.use(VTooltip)

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}
miniToastr.init({ types: toastTypes })

Vue.use(Router)
Vue.use(VueCollapse)

Vue.mixin(globalMixin.notificationMixin())

Vue.filter('formatDate', (value, formatStr) => {
  if (value) {
    if (!formatStr) {
      // eslint-disable-next-line
      formatStr = 'MM/dd/yyyy HH:MM';
    }
    if (formatStr === 'at') {
      return `${format(new Date(value), 'MM/dd/yyyy')} at ${format(new Date(value), 'HH:mm')}`
    }
    return format(new Date(value), formatStr)
  }
  return value
})

const token = localStorage.getItem('token')
if (token) {
  // eslint-disable-next-line
  axios.defaults.headers.common['Authorization'] = token;
}


/* eslint-disable no-new */
new Vue({
  el: '#mental-app',
  router,
  store,
  render: h => h(MentalApp)
})
